// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form__Form___215B1","AssignTabs":"Form__AssignTabs___Gr8mB","AssignBody":"Form__AssignBody___3noj0"};